(() => {
  const sliders = qsa(`.js-menu__item-thumbs-slider`);

  if(sliders && !isDesktop()) {
    sliders.forEach((slide, index) => {
      new Swiper (`.js-menu__item-thumbs-slider-${ index }`, {
        threshold: 11, // to prevent the click twice
        slidesPerView: 'auto',
        spaceBetween: 4,
        allowTouchMove: true,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,
        pagination: {
          el: `.js-menu__item-thumbs-pagination-${ index }`,
          type: 'progressbar',
        },
      });
    })
  }
})();
